import IntlMessage from '../../../../../helpers/intlMessage';
import React from 'react';

const inicialState = {
  modalJustificativa: false,
  modalLamina: false,
  listarLaminas: [],
  carregarLaminas: false,
  laminaText: <IntlMessage id = "dashboards.examDetail.addBlade"/>,
  laminaId: null,
  isEdicao: false,
  carregarEdicao: false,
  activeTab: '1',
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/app/common/requisicaoCongelacao/tabs/lamina/lamina.state.js